export default __webpack_public_path__ + "static/media/gallery12.5b1c2672.webp";